<div class="dialog-container">

    <!-- ── Header ─────────────────────────────────────────────────────────── -->
    <div class="dialog-header">
        <div class="g-just-flex gap-12 align-items-center">
            <mat-icon class="header-icon">preview</mat-icon>
            <div>
                <h2 mat-dialog-title class="mb-0">
                    @if (isExisting) {
                        Manage Task Group
                    } @else {
                        Review Generated Tasks
                    }
                </h2>
                <p class=" subtitle-text-color-2 mb-0">
                    {{ totalTaskCount }} task{{ totalTaskCount !== 1 ? 's' : '' }} across
                    {{ taskGroups.length }} group{{ taskGroups.length !== 1 ? 's' : '' }}
                </p>
            </div>
        </div>
        <button mat-icon-button (click)="cancel()" matTooltip="Cancel">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="dialog-content">

        @for (group of taskGroups; track group.groupId) {

        <!-- ── Task Group Card (exact design reference) ──────────────────── -->
        <div class="default-task my-15">

            <!-- <div class="default-task-title mb-4">{{ getGroupTitle(group) }}</div>
            <div class="default-task-subtitle subtitle-text-color-2  mb-0">
                {{ getTaskStatusSummary(group.tasks) }}
            </div> -->

            <div class="task-details my-20" style="padding-left: 20px; ">

                <!-- Resource type / actual order name label -->
                @if (group.tasks[0].focus?.reference) {
                <div class="super-title resource-name"
                    [appReferenceDisplay]="group.tasks[0].focus.reference"
                    [instantFetchAndReplace]="true"
                    [keepReference]="false">
                    {{ getResourceName(group.tasks[0]) }}
                </div>
                } @else {
                <div class="super-title resource-name">
                    {{ getResourceName(group.tasks[0]) }}
                </div>
                }

                <!-- Task name + action buttons -->
                <div class="task-header">
                    <div class="task-header-left">
                        <div class="task-name">{{ group.tasks[0].description || 'Unnamed Task' }}</div>
                        <div class="task-description subtitle-text-color-2  mb-15">
                            {{ getTaskStatusSummary(group.tasks) }}
                        </div>
                    </div>
                    <div class="task-header-right">
                        <button class="action-button g-just-flex justify-content-start gap-8"
                            (click)="toggleOccurrences(group.groupId)"
                            [matTooltip]="'Review all ' + group.tasks.length + ' occurrences'">
                            <mat-icon>list_alt</mat-icon>
                            <span>{{ group.tasks.length }} Tasks</span>
                        </button>
                        <div class="more-btn g-just-flex" [matMenuTriggerFor]="groupMenu" style="position: relative;">
                            <mat-icon>more_vert</mat-icon>
                        </div>
                        <mat-menu #groupMenu="matMenu">
                            <button mat-menu-item (click)="toggleOccurrences(group.groupId)">
                                <mat-icon>expand_more</mat-icon>
                                <span>{{ expandedGroups.has(group.groupId) ? 'Collapse' : 'Expand' }} Occurrences</span>
                            </button>
                            <button mat-menu-item (click)="selectAllVisible(group); toggleOccurrences(group.groupId)">
                                <mat-icon>select_all</mat-icon>
                                <span>Select All in Group</span>
                            </button>
                            <mat-divider></mat-divider>
                            @if (canCancelGroup(group)) {
                            <button mat-menu-item (click)="selectAllVisible(group); markSelectedCancelled(group)"
                                class="danger-item">
                                <mat-icon>cancel</mat-icon>
                                <span>Mark Group as Cancelled</span>
                            </button>
                            }
                            @if (canReassignGroup(group)) {
                            <button mat-menu-item (click)="selectAllVisible(group); reassignSelected(group)"
                                class="warn-item">
                                <mat-icon>person_add</mat-icon>
                                <span>Reassign Group</span>
                            </button>
                            }
                            @if (!isExisting) {
                            <mat-divider></mat-divider>
                            <button mat-menu-item (click)="selectAllVisible(group); removeSelectedTasks(group)"
                                class="danger-item">
                                <mat-icon>delete_sweep</mat-icon>
                                <span>Remove Group from Batch</span>
                            </button>
                            }
                        </mat-menu>
                    </div>
                </div>

                <!-- Patient row -->
                <div class="middle-patient g-just-flex gap-8 mb-15 justify-content-start">
                    <!-- <div class="rounded-icon-wrapper g-just-flex gap-8"> -->
                        <mat-icon>person</mat-icon>
                    <!-- </div> -->
                    <div class="g-just-flex gap-30">
                        <div class="g-just-flex flex-column gap-0" style="align-items: flex-start;">
                            <span>{{ patientName || 'Loading Patient...' }}</span>
                            <span class=" subtitle-text-color-2">{{ patientPid }}</span>
                        </div>
                    </div>
                </div>

                <!-- Recurrence + date range + times -->
                <div class="recurrence g-just-flex justify-content-start">
                    <div class="recurrence-pattern g-just-flex gap-12 flex-column justify-content-start">

                        <!-- Pattern + date range row -->
                        <div class="pipe-separated g-just-flex justify-content-start gap-12 mb-8">
                            <div class="pattern g-just-flex justify-content-start gap-12">
                                <mat-icon>event_repeat</mat-icon>
                                <span>{{ getRecurrencePattern(group.tasks) }}</span>
                            </div>
                            <div class="pipe">|</div>
                            <div class="pattern g-just-flex justify-content-start gap-8">
                                <span>{{ formatDate(getEarliestDate(group.tasks)) }}</span>
                                <div class="rounded-icon">
                                    <mat-icon>arrow_forward</mat-icon>
                                </div>
                                <span>{{ formatDate(getLatestDate(group.tasks)) }}</span>
                            </div>
                        </div>

                        <!-- Unique times (repetition summary — same times repeat every day) -->
                        <div class="times g-just-flex justify-content-start gap-12">
                            <mat-icon>access_time</mat-icon>
                            <div class="time-list subtitle-text-color-2 g-just-flex justify-content-start gap-12  mb-5">
                                @for (timeStr of getUniqueTimes(group.tasks); track timeStr; let idx = $index) {
                                    @if (idx < 6) {
                                        <span class="recurrence-time">{{ formatTimeString(timeStr) }}</span>
                                    }
                                }
                                @if (getUniqueTimes(group.tasks).length > 6) {
                                    <span class="recurrence-time muted">+{{ getUniqueTimes(group.tasks).length - 6 }} more</span>
                                }
                            </div>
                        </div>

                    </div>
                </div>

                <div class="mt-12"></div>
                <mat-divider></mat-divider>
                <div class="mb-12"></div>

                <!-- Bottom row: focus link + status -->
                <div class="g-just-flex " style="justify-content: space-between;">
                    <div class="g-just-flex gap-8">
                        @if (group.tasks[0].focus?.reference) {
                        <span class="g-just-flex gap-4" style="color: var(--mat-sys-primary); text-decoration: none;">
                            <span [appReferenceDisplay]="group.tasks[0].focus.reference"
                                [instantFetchAndReplace]="true"  [maxWidth]="'360px'">
                                Linked to: {{ group.tasks[0].focus.reference }}
                            </span>
                            <mat-icon style="font-size:14px;height:14px;width:14px;">chevron_right</mat-icon>
                        </span>
                        } @else {
                        <span class="subtitle-text-color-2">No linked resource</span>
                        }
                    </div>
                    <div class="assignee g-just-flex gap-6">
                        @if (group.tasks[0].owner?.reference) {
                        <mat-icon style="font-size:14px;height:14px;width:14px;" class="subtitle-text-color-2">person</mat-icon>
                        <span class="subtitle-text-color-2">{{ group.tasks[0].owner.reference }}</span>
                        } @else {
                        <span class="subtitle-text-color-2">Status: {{ group.tasks[0].status || 'requested' }}</span>
                        }
                    </div>
                </div>

                <!-- ── Occurrence Panel Toggle ─────────────────────────────── -->
                <div class="occurrences-section mt-12">
                    <button class="occurrences-toggle g-just-flex gap-8 align-items-center"
                        (click)="toggleOccurrences(group.groupId)">
                        <mat-icon style="font-size:16px;width:16px;height:16px;transition:transform 0.2s"
                            [style.transform]="expandedGroups.has(group.groupId) ? 'rotate(180deg)' : 'rotate(0deg)'">
                            expand_more
                        </mat-icon>
                        <span>{{ expandedGroups.has(group.groupId) ? 'Collapse' : 'View all' }} {{ group.tasks.length }} occurrence{{ group.tasks.length !== 1 ? 's' : '' }}</span>
                    </button>

                    @if (expandedGroups.has(group.groupId)) {

                    <!-- ── Filter bar ──────────────────────────────────────── -->
                    <div class="filter-bar g-just-flex gap-8 align-items-center">
                        <span class=" subtitle-text-color-2">Filter:</span>

                        <button class="filter-chip" [class.active]="getFilterMode(group.groupId) === 'all'"
                            (click)="setFilter(group.groupId, 'all')">All</button>

                        <div class="filter-chip-group g-just-flex gap-4">
                            <button class="filter-chip" [class.active]="getFilterMode(group.groupId) === 'day'"
                                (click)="setFilter(group.groupId, 'day', '')">By Day</button>
                            @if (getFilterMode(group.groupId) === 'day') {
                            <select class="filter-select" [ngModel]="getFilterValue(group.groupId)"
                                (ngModelChange)="setFilter(group.groupId, 'day', $event)">
                                <option value="">All days</option>
                                @for (day of getUniqueDays(group.tasks); track day) {
                                <option [value]="day">{{ day }}</option>
                                }
                            </select>
                            }
                        </div>

                        <div class="filter-chip-group g-just-flex gap-4">
                            <button class="filter-chip" [class.active]="getFilterMode(group.groupId) === 'time'"
                                (click)="setFilter(group.groupId, 'time', '')">By Time</button>
                            @if (getFilterMode(group.groupId) === 'time') {
                            <select class="filter-select" [ngModel]="getFilterValue(group.groupId)"
                                (ngModelChange)="setFilter(group.groupId, 'time', $event)">
                                <option value="">All times</option>
                                @for (t of getUniqueTimes(group.tasks); track t) {
                                <option [value]="t">{{ formatTimeString(t) }}</option>
                                }
                            </select>
                            }
                        </div>

                        <div class="filter-chip-group g-just-flex gap-4">
                            <button class="filter-chip" [class.active]="getFilterMode(group.groupId) === 'week'"
                                (click)="setFilter(group.groupId, 'week', '')">By Week</button>
                            @if (getFilterMode(group.groupId) === 'week') {
                            <select class="filter-select" [ngModel]="getFilterValue(group.groupId)"
                                (ngModelChange)="setFilter(group.groupId, 'week', $event)">
                                <option value="">All weeks</option>
                                @for (w of getUniqueWeeks(group.tasks); track w) {
                                <option [value]="w">{{ w }}</option>
                                }
                            </select>
                            }
                        </div>

                        <span class=" subtitle-text-color-2 ms-auto">
                            {{ getFilteredTasks(group).length }} shown
                        </span>
                    </div>

                    <!-- ── Bulk action toolbar (appears when tasks are selected) ── -->
                    @if (getSelectedCount(group.groupId) > 0) {
                    <div class="bulk-actions-bar g-just-flex gap-8 align-items-center">
                        <span class="" style="font-weight:500;">
                            {{ getSelectedCount(group.groupId) }} selected
                        </span>
                        <div class="g-just-flex gap-6 ms-auto">
                            @if (canReassignGroup(group)) {
                            <button mat-stroked-button class="bulk-btn reassign"
                                (click)="reassignSelected(group)"
                                matTooltip="Assign a practitioner owner to selected tasks">
                                <mat-icon>person_add</mat-icon>
                                Reassign
                            </button>
                            }
                            @if (canCancelSelected(group)) {
                            <button mat-stroked-button class="bulk-btn cancel-status"
                                (click)="markSelectedCancelled(group)"
                                matTooltip="Mark selected as cancelled status (they will be created with cancelled status)">
                                <mat-icon>block</mat-icon>
                                Mark Cancelled
                            </button>
                            }
                            @if (!isExisting) {
                            <button mat-stroked-button class="bulk-btn remove"
                                (click)="removeSelectedTasks(group)"
                                matTooltip="Remove from submission batch entirely">
                                <mat-icon>delete_outline</mat-icon>
                                Remove
                            </button>
                            }
                            <button mat-icon-button class="bulk-btn deselect"
                                (click)="deselectAll(group.groupId)" matTooltip="Clear selection">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>
                    }

                    <!-- ── Individual occurrences list ─────────────────────── -->
                   <div class="scrollable-occurrence-wrapper">
                    <div class="occurrences-list">

                        <!-- List header with select-all -->
                        <div class="occurrence-list-header g-just-flex gap-12 align-items-center">
                            <mat-checkbox
                                [checked]="isAllVisibleSelected(group)"
                                (change)="$event.checked ? selectAllVisible(group) : deselectAll(group.groupId)"
                                matTooltip="Select / deselect all visible">
                            </mat-checkbox>
                            <span class=" subtitle-text-color-2" style="flex:1">Date</span>
                            <span class=" subtitle-text-color-2" style="width:90px">Start</span>
                            <span class=" subtitle-text-color-2" style="width:90px">End</span>
                            <span class=" subtitle-text-color-2" style="width:80px">Duration</span>
                            <span class=" subtitle-text-color-2" style="width:90px">Status</span>
                            <span class=" subtitle-text-color-2" style="width:26px"></span>
                        </div>

                        @for (item of getFilteredTasks(group); track item.originalIndex) {
                        @let task = item.task;
                        @let start = task.restriction?.period?.start || task.executionPeriod?.start;
                        @let end = task.restriction?.period?.end || task.executionPeriod?.end;

                        <div class="occurrence-row g-just-flex gap-12 align-items-center"
                            [class.selected]="isSelected(group.groupId, item.originalIndex)"
                            [class.status-cancelled]="task.status === 'cancelled'">

                            <mat-checkbox
                                [checked]="isSelected(group.groupId, item.originalIndex)"
                                (change)="toggleTaskSelection(group.groupId, item.originalIndex)">
                            </mat-checkbox>

                            <div class="occ-date g-just-flex gap-6 align-items-center" style="flex:1">
                                <mat-icon style="font-size:14px;width:14px;height:14px;" class="subtitle-text-color-2">calendar_today</mat-icon>
                                <span>{{ formatDate(start) }}</span>
                            </div>

                            <span class="occ-time" style="width:90px">{{ formatTime(start) }}</span>
                            <span class="occ-time subtitle-text-color-2" style="width:90px">{{ formatTime(end) }}</span>

                            <span class="occ-duration subtitle-text-color-2" style="width:80px">
                                @if (start && end) {
                                    {{ getDurationMins(start, end) }} min
                                }
                            </span>

                            <span class="occ-status-chip" style="width:90px" [attr.data-status]="task.status || 'requested'">
                                {{ task.status || 'requested' }}
                            </span>

                            <!-- Per-row quick action -->
                            <button mat-icon-button style="width:26px;height:26px"
                                [matMenuTriggerFor]="rowMenu"
                                matTooltip="Actions">
                                <mat-icon style="font-size:16px">more_vert</mat-icon>
                            </button>
                            <mat-menu #rowMenu="matMenu">
                                @if (canCancelTask(task)) {
                                <button mat-menu-item (click)="markSelectedCancelled(group); toggleTaskSelection(group.groupId, item.originalIndex)">
                                    <mat-icon>block</mat-icon> Mark Cancelled
                                </button>
                                }
                                @if (canReassignTask(task)) {
                                <button mat-menu-item (click)="reassignTaskAt(group, item.originalIndex)">
                                    <mat-icon>person_add</mat-icon> Reassign
                                </button>
                                }
                                @if (!isExisting) {
                                <mat-divider></mat-divider>
                                <button mat-menu-item (click)="toggleTaskSelection(group.groupId, item.originalIndex); removeSelectedTasks(group)">
                                    <mat-icon>delete_outline</mat-icon> Remove from Batch
                                </button>
                                }
                            </mat-menu>
                        </div>
                        }

                        @if (getFilteredTasks(group).length === 0) {
                        <div class="occurrence-row justify-content-center subtitle-text-color-2 ">
                            No occurrences match this filter.
                        </div>
                        }

                    </div>
                    </div>
                    } <!-- end expanded -->

                </div><!-- end occurrences-section -->

            </div><!-- end task-details -->
        </div><!-- end default-task -->
        }

    </mat-dialog-content>

    <!-- ── Footer actions ──────────────────────────────────────────────────── -->
    <mat-dialog-actions align="end" class="dialog-actions">
        <div class="g-just-flex gap-8 align-items-center" style="flex:1">
            <mat-icon class="subtitle-text-color-2" style="font-size:18px;width:18px;height:18px;">info_outline</mat-icon>
            <span class=" subtitle-text-color-2">
                @if (isExisting) {
                    Tasks will be updated in FHIR R4
                } @else {
                    {{ totalTaskCount }} task{{ totalTaskCount !== 1 ? 's' : '' }} will be created in FHIR R4
                }
            </span>
        </div>
        <button mat-button (click)="cancel()">
            <mat-icon>close</mat-icon> Cancel
        </button>
        <button mat-raised-button color="primary" (click)="confirm()" [disabled]="totalTaskCount === 0">
            <mat-icon>check_circle</mat-icon>
            @if (isExisting) {
                Save Changes
            } @else {
                Confirm &amp; Create {{ totalTaskCount }} Task{{ totalTaskCount !== 1 ? 's' : '' }}
            }
        </button>
    </mat-dialog-actions>

</div>
